module.exports = __webpack_public_path__ + "static/media/TeamIcon.34b6adad.svg";